import moment from 'moment-jalaali';
export const sortLatestExpireDate = (array) => {
  console.log(
    'arrayarrayarrayarray---->',
    array instanceof Array
  );

  if (array instanceof Array === false) {
    return;
  }
  const sortedArray = array.sort((a, b) => {
    const aDate = moment(
      a.MohlateSabt,
      'jYYYY/jM/jD'
    ).valueOf();
    const bDate = moment(
      b.MohlateSabt,
      'jYYYY/jM/jD'
    ).valueOf();
    // if (aDate === bDate) {
    //   const aTime = moment(a.Time, "HH:mm").valueOf();
    //   const bTime = moment(b.Time, "HH:mm").valueOf();
    //   return bTime - aTime;
    // }
    return bDate - aDate;
  });
  return sortedArray;
};
